import { memo } from 'react';
import { interpolate, useAnimatedStyle } from 'react-native-reanimated';
import { Box } from '@bonanza-social/moonlight';
import { PrizeWallShakeProps } from './PrizeWallShake.types';

function PrizeWallShake({ children, animatedValue }: PrizeWallShakeProps) {
  const animatedStyle = useAnimatedStyle(() => ({
    transform: [
      { translateX: interpolate(animatedValue.value, [-1, 1], [-3, 3]) },
    ],
  }));

  return <Box animatedStyle={animatedStyle}>{children}</Box>;
}

export default memo(PrizeWallShake);
